// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IServiceCreateDto
 */
export interface IServiceCreateDto {
    /**
     * 
     * @type {string}
     * @memberof IServiceCreateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof IServiceCreateDto
     */
    category_type: IServiceCreateDtoCategoryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IServiceCreateDto
     */
    service_type: IServiceCreateDtoServiceTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IServiceCreateDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}
/**
* @export
* @enum {string}
*/
export enum IServiceCreateDtoServiceTypeEnum {
    CARD = 'CARD',
    MANUAL_CLAIM = 'MANUAL_CLAIM',
    HEALTH_PLAN = 'HEALTH_PLAN',
    HIDDEN = 'HIDDEN'
}


/**
 * Check if a given object implements the IServiceCreateDto interface.
 */
export function instanceOfIServiceCreateDto(value: object): value is IServiceCreateDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('category_type' in value) || value['category_type'] === undefined) return false;
    if (!('service_type' in value) || value['service_type'] === undefined) return false;
    return true;
}

export function IServiceCreateDtoFromJSON(json: any): IServiceCreateDto {
    return IServiceCreateDtoFromJSONTyped(json, false);
}

export function IServiceCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IServiceCreateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'category_type': json['category_type'],
        'service_type': json['service_type'],
    };
}

export function IServiceCreateDtoToJSON(json: any): IServiceCreateDto {
    return IServiceCreateDtoToJSONTyped(json, false);
}

export function IServiceCreateDtoToJSONTyped(value?: IServiceCreateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'category_type': value['category_type'],
        'service_type': value['service_type'],
    };
}

